"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var LineOptions = /** @class */ (function () {
    function LineOptions() {
        this.width = 500;
        this.height = 500;
        this.margin = { top: 20, right: 20, bottom: 30, left: 40 };
        this.data = Promise.resolve({});
        this.isDefined = function (d) { return !isNaN(d); };
    }
    return LineOptions;
}());
exports.default = LineOptions;
